import circleLog from '../assets/uvtv.png';
const Details={
    "url":"https://uvtv-Mso.Impactsms.in",
    "circlelogo":circleLog,
    "blueColor":"#040B26",
    "mustard":"#040B26",
    "garland":"#fff",
    "bottomNav":"#366cc8"
}
export default Details;